<template>
  <div class="form-check form-switch">
    <input
      class="form-check-input"
      type="checkbox"
      id="onlyShowIncomplete"
      v-model="onlyShowIncomplete"
    />
    <label class="form-check-label" for="onlyShowIncomplete"
      >Show only incomplete</label
    >
  </div>

  <alzata-odata-table
    ref="grid"
    clickable
    title="Task Items"
    endpoint="/api/v1/taskitems"
    defaultOrder="DueDate desc"
    :filters="allFilters"
    :columns="[
      {
        id: 'Title',
        label: 'Title',
        sortable: true,
      },
      {
        id: 'Category',
        label: 'Category',
        sortable: true,
      },
      {
        id: 'AssignedToUserId',
        label: 'Assigned To',
        sortable: true,
        formatter: (taskItem) => {
          return `${taskItem.assignedToUser.displayName}`;
        },
      },
      {
        id: 'IsCompleted',
        label: 'Is Completed',
        sortable: true,
        formatter: (taskItem) => {
          return `${taskItem.isCompleted}`;
        },
      },
      {
        id: 'CompletionDate',
        label: 'Completion Date',
        sortable: true,
        formatter: (x) => {
          return formatDateFull(x.completionDate);
        },
      },
      {
        id: 'DueDate',
        label: 'Due Date',
        sortable: true,
        formatter: (x) => {
          return formatDateFull(x.dueDate);
        },
      },
    ]"
    :actions="[
      {
        id: 'edit',
        icon: (item) => 'far/pencil',
        tooltip: 'Edit',
        default: true,
        click: showEdit,
      },
      {
        id: 'delete',
        icon: (item) => 'far/trash',
        tooltip: 'Delete',
        default: true,
        click: showDelete,
      },
    ]"
  >
    <template v-slot:format-due-date="{ item }">
      <span
        :class="{ 'text-danger': isOverdue(item) }"
        :title="isOverdue(item) ? 'Overdue' : ''"
      >
        <alzata-icon v-if="isOverdue(item)" icon="fas/exclamation-triangle" />
        {{ formatDateFull(item.dueDate) }}
      </span>
    </template>
    <template v-slot:buttons>
      <button
        type="button"
        class="btn btn-primary btn-sm ms-1"
        @click="showCreate({})"
      >
        <alzata-icon icon="far/plus-circle" /> Add Task Item
      </button>
    </template>
  </alzata-odata-table>
  <edit-taskItem-dialog ref="editDialog" @save="save" @update="update" />
  <create-taskItem-dialog ref="createDialog" @save="save" @update="update" />
  <delete-taskItem-dialog ref="deleteDialog" @deleteTaskItem="deleteTaskItem" />
</template>

<script>
import EditTaskItemDialog from "@/dialogs/EditTaskItemDialog.vue";
import CreateTaskItemDialog from "@/dialogs/CreateTaskItemDialog.vue";
import DeleteTaskItemDialog from "@/dialogs/DeleteTaskItemDialog.vue";
import { DateTime } from "luxon";
export default {
  name: "TaskItemList",
  components: {
    EditTaskItemDialog,
    CreateTaskItemDialog,
    DeleteTaskItemDialog
  },
  props: {
    veteranId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      onlyShowIncomplete: true
    };
  },
  computed: {
    console: () => console,
    window: () => window,
    allFilters() {
      const allFilters = [];

      if (this.veteranId) {
        allFilters.push(`assignedToUserId eq ${this.veteranId}`);
      }

      if (this.onlyShowIncomplete) {
        allFilters.push("isCompleted eq false");
      }

      return allFilters;
    },
  },
  methods: {
    showEdit(taskItem) {
      this.$refs.grid.reload();
      this.$refs.editDialog.clear();
      this.$refs.editDialog.show(taskItem);
    },
    showCreate(taskItem) {
      this.$refs.grid.reload();
      this.$refs.createDialog.show(taskItem);
    },
    showDelete(taskItem) {
      this.$refs.deleteDialog.show(taskItem);
    },
    async save(taskItem) {
      const body = {
        title: taskItem.title,
        description: taskItem.description,
        linkUrl: taskItem.linkUrl,
        category: taskItem.category,
        dueDate: taskItem.dueDate,
        assignedToUserIdList: taskItem.assignedToUserIds,
      };

      const res = await this.apiClient.postJson("/api/v1/taskitems", {
        body,
      });
      if (!res.success) {
        alert("error saving task item");
        return;
      }
      taskItem.id = res.id;

      this.$refs.grid.reload();
      this.$refs.createDialog.hide();
      
    },
    async update(taskItem) {
      const body = {
        title: taskItem.title,
        description: taskItem.description,
        linkUrl: taskItem.linkUrl,
        category: taskItem.category,
        dueDate: taskItem.dueDate,
        assignedToUserId: taskItem.assignedToUserId.id,
      };

      await this.apiClient.putJson(`/api/v1/taskitems/${taskItem.id}`, {
        body,
      });

      this.$refs.grid.reload();
      this.$refs.editDialog.hide();
    },
    async deleteTaskItem(taskItem) {
      await this.apiClient.doDelete(`/api/v1/taskItems/${taskItem.id}`, { });

      this.$refs.grid.reload();
      this.$refs.deleteDialog.hide();
    },
    formatDateFull(dateString) {
      if (!dateString) {
        return "";
      }

      const date = DateTime.fromISO(dateString);

      const formatted = `${this.formatDate(date)}`;
      return formatted;
    },
    formatDate(date) {
      const formatted = date.toLocaleString(DateTime.DATE_SHORT);
      return formatted;
    },
    formatDateRelative(date) {
      const relative = date.toRelative();
      return relative;
    },
    isOverdue(taskItem) {
      if (taskItem.isCompleted) {
        return false;
      }

      const dateString = taskItem.dueDate;
      if (!dateString) {
        return false;
      }

      const date = DateTime.fromISO(dateString);
      const now = DateTime.local();

      return date < now;
    },
  },
};
</script>
